import { useEffect, useState } from 'react';

import { useBrowserTabControl } from '../../../hooks/useBrowserTabControl';

const DEFAULT_REQUERY_INTERVAL = 2 * 60 * 1000;

type UseRideReQueryingProps = {
  setTimerForRequerying: () => void;
};

type QueryParamsWithStateAndTab = {
  state?: string;
  tab?: string;
  [key: string]: string | number | boolean | undefined;
};

export const useRideReQuerying = (fetchRides, queryParams): UseRideReQueryingProps => {
  const isTabActive = useBrowserTabControl();
  const [intervalID, setMyIntervalID] = useState<number | null>(null);
  const pageName = resolvePageFromParams(queryParams);

  const [shouldUpdate, setShouldUpdate] = useState<boolean>(false);

  useEffect(() => {
    checkAndClearInterval();

    if (pageName === 'daily-inbound-rides') {
      setTimerForRequerying();
    }

    return () => checkAndClearInterval();
  }, []);

  useEffect(() => {
    if (shouldUpdate && isTabActive) {
      fetchRidesBasedOnPage(pageName, true);
    }
    setShouldUpdate(false);
  }, [shouldUpdate, isTabActive]);

  const fetchRidesBasedOnPage = (page: string, silentReFetching: boolean) => {
    switch (page) {
      case 'active-rides':
        fetchRides(queryParams.query || '', queryParams.state, queryParams.fromDate, silentReFetching);
        break;
      case 'daily-inbound-rides':
        fetchRides({ ...queryParams, silentReFetching: silentReFetching });
        break;
      default:
        return null;
    }

    return null;
  };

  const checkAndClearInterval = () => {
    if (intervalID) {
      clearInterval(intervalID);
    }
  };

  const setTimerForRequerying = () => {
    checkAndClearInterval();
    const myIntervalId = window.setInterval(() => setShouldUpdate(true), DEFAULT_REQUERY_INTERVAL);

    setMyIntervalID(myIntervalId);
  };

  return {
    setTimerForRequerying,
  };
};

const resolvePageFromParams = (params: QueryParamsWithStateAndTab): string => {
  if (params.state === 'all') {
    return 'active-rides';
  } else if (params.tab === 'inbound') {
    return 'daily-inbound-rides';
  }

  return '';
};
